import { useEffect, useState } from "react";

/**
 * Floating sticky "Kindly RSVP" CTA shown on mobile only.
 * Hides itself when the RSVP form is in view or once the user has already
 * submitted an RSVP (IntersectionObserver on [data-testid="rsvp-form"] /
 * [data-testid="rsvp-thanks"]).
 */
export default function RsvpFloatingCta({ accent = "#B89B5E" }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Wait a moment for template to hydrate its RSVP section
    const timer = setTimeout(() => {
      const targets = [
        document.querySelector('[data-testid="rsvp-form"]'),
        document.querySelector('[data-testid="rsvp-thanks"]'),
      ].filter(Boolean);
      if (targets.length === 0) return;

      // If the thank-you confirmation is already on screen, hide permanently
      if (document.querySelector('[data-testid="rsvp-thanks"]')) {
        setVisible(false);
        return;
      }

      const io = new IntersectionObserver((entries) => {
        // If form is visible >=40%, hide the floating CTA (avoid double-CTA)
        const anyVisible = entries.some((e) => e.isIntersecting && e.intersectionRatio > 0.4);
        setVisible(!anyVisible);
      }, { threshold: [0, 0.4, 1] });
      targets.forEach((t) => io.observe(t));

      return () => io.disconnect();
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  const scrollToRsvp = () => {
    const el = document.querySelector('[data-testid="rsvp-card"]') || document.querySelector('[data-testid="rsvp-form"]') || document.getElementById("rsvp");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollToRsvp}
      aria-label="Scroll to RSVP form"
      data-testid="rsvp-floating-cta"
      className="md:hidden fixed bottom-5 right-4 z-40 px-4 py-3 text-[10px] uppercase tracking-[0.3em] shadow-2xl border border-white/30 backdrop-blur-md text-white font-semibold rounded-full animate-float whitespace-nowrap"
      style={{ background: `${accent}E6` }}
    >
      ♥ Kindly RSVP
    </button>
  );
}
